import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Navigation from './components/Navigation';
import StreamPage from './pages/StreamPage';
import EmbedView from './pages/EmbedView';

// Layout for the main website
const WebsiteLayout = () => (
  <div className="bg-[#F8FAFC] min-h-screen">
    <Navigation />
    <div className="pt-20">
      <Outlet />
    </div>
  </div>
);

// Layout for Embeds (Strictly Isolated)
const EmbedLayout = () => (
  <div className="bg-transparent w-full h-screen overflow-hidden">
    <Outlet />
  </div>
);

function App() {
  const streamUrl = "http://stream.radiojar.com/98mxa4t2c0nwv";
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/43aece2c60808d1ccb768fe9bea97d59a6d817dd340535725dd5c7fa72ea8e057f5a392df509537a8b1d8bce30fb3a2f/images/aW1hZ2UvanBlZw==/940fed55ead5745df056cf189658325c.jpg";

  return (
    <Router>
      <Routes>
        {/* Main Website - With Navigation */}
        <Route element={<WebsiteLayout />}>
          <Route path="/" element={<StreamPage title="Broadcast: Stream 1" streamUrl={streamUrl} logoUrl={logoUrl} type="cute" />} />
          <Route path="/stream-2" element={<StreamPage title="Broadcast: Stream 2" streamUrl={streamUrl} logoUrl={logoUrl} type="widget" />} />
        </Route>

        {/* Embed Routes - Zero UI Overlap */}
        <Route element={<EmbedLayout />}>
          <Route path="/embed/stream-1" element={<EmbedView streamUrl={streamUrl} logoUrl={logoUrl} type="cute" />} />
          <Route path="/embed/stream-2" element={<EmbedView streamUrl={streamUrl} logoUrl={logoUrl} type="widget" />} />
        </Route>

        {/* Fallback for broken links */}
        <Route path="*" element={<div className="flex h-screen items-center justify-center font-black text-gray-200 uppercase tracking-widest">404: Not Found</div>} />
      </Routes>
    </Router>
  );
}

export default App;